import { useTheme } from "@mui/material";
import { createSxStyles } from "../../../common/createSxStyles";

export const useDataSubjectsStyles = () => {
    const theme = useTheme();
    return createSxStyles({
        container: {
            height: "100%",
            display: "flex",
            flexDirection: "column",
        },
        switchBoxContainer: {
            marginBottom: theme.spacing(2.5),
            width: 180,
        },
        paperContainer: {
            flex: "1",
            display: "flex",
            flexDirection: "column",
        },
        checkIcon: {
            height: "20px !important",
        },
        bold: {
            fontWeight: theme.typography.fontWeightBold,
        },
        iconContainer: {
            display: "flex",
        },
    });
};
